import { render, staticRenderFns } from "./PollThanks.vue?vue&type=template&id=6a7697b0&"
import script from "./PollThanks.vue?vue&type=script&lang=js&"
export * from "./PollThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports